import { SatisfactionAnswerType } from "../../shared/live-class-survey/live-class-survey-data-types";
import { LiveClassFeedbackRatingOptionType } from "./survey-questions-id.enum";
import { LiveClassFeedbackRatingQuestionTypes } from "./survey-questions-id.enum";
import { LiveClassFeedbackSendReasonOptionType } from "./survey-questions-id.enum";

export const SurveyQuestionsIdMap = {
  [SatisfactionAnswerType.HAPPY]: [
    {
       profileQuestionId: LiveClassFeedbackRatingQuestionTypes.RATING,
       profileQuestionOptionId: LiveClassFeedbackRatingOptionType.RATING_POSITIVE
    },
    {
       profileQuestionId: LiveClassFeedbackRatingQuestionTypes.SEND_REASON,
       profileQuestionOptionId: LiveClassFeedbackSendReasonOptionType.NO
    }
  ],
  [SatisfactionAnswerType.SAD]: [
    {
      profileQuestionId: LiveClassFeedbackRatingQuestionTypes.RATING,
      profileQuestionOptionId: LiveClassFeedbackRatingOptionType.RATING_NEGATIVE
   },
   {
      profileQuestionId: LiveClassFeedbackRatingQuestionTypes.SEND_REASON,
      profileQuestionOptionId: LiveClassFeedbackSendReasonOptionType.YES
   }
  ]
}



// WEBPACK FOOTER //
// ./ts/app/teacher-feedback/teacher-liveclass-feedback-modal/survey-questions-id-map.ts